// Static mapping of ISO 3166-1 alpha-2 codes to [longitude, latitude] centroids
// Covers all HIH (Hand in Hand) initiative countries plus a broad global set
const countryCentroids: Record<string, [number, number]> = {
  AF: [67.7, 33.9],
  AL: [20.2, 41.2],
  DZ: [2.6, 28.0],
  AO: [17.9, -11.2],
  AR: [-63.6, -38.4],
  AM: [45.0, 40.1],
  AZ: [47.6, 40.1],
  BD: [90.4, 23.7],
  BJ: [2.3, 9.3],
  BT: [90.4, 27.5],
  BO: [-64.0, -17.0],
  BW: [24.7, -22.3],
  BR: [-51.9, -14.2],
  BF: [-1.6, 12.4],
  BI: [29.9, -3.4],
  CV: [-24.0, 16.0],
  KH: [105.0, 12.7],
  CM: [12.4, 3.9],
  CF: [20.9, 6.6],
  TD: [18.7, 15.5],
  CL: [-71.5, -35.7],
  CN: [104.2, 35.9],
  CO: [-74.3, 4.1],
  KM: [43.3, -11.6],
  CG: [15.2, -0.2],
  CD: [23.7, -2.9],
  CI: [-5.6, 7.5],
  CU: [-79.5, 22.0],
  DJ: [42.6, 11.8],
  DO: [-70.2, 18.7],
  EC: [-77.8, -1.8],
  EG: [30.8, 26.8],
  SV: [-88.9, 13.8],
  GQ: [10.3, 1.7],
  ER: [39.8, 15.2],
  ET: [40.5, 9.1],
  FJ: [178.1, -17.7],
  GA: [11.6, -0.8],
  GM: [-15.3, 13.4],
  GH: [-1.0, 7.9],
  GT: [-90.2, 15.8],
  GN: [-11.8, 11.0],
  GW: [-15.2, 11.8],
  GY: [-58.9, 4.9],
  HT: [-72.3, 18.9],
  HN: [-86.6, 15.2],
  IN: [78.9, 20.6],
  ID: [113.9, -0.8],
  IQ: [43.7, 33.2],
  IR: [53.7, 32.4],
  JM: [-77.3, 18.1],
  JO: [37.1, 31.0],
  KZ: [66.9, 48.0],
  KE: [37.9, 0.0],
  KI: [-168.7, 0.0],
  KG: [74.8, 41.2],
  LA: [102.5, 18.2],
  LB: [35.9, 33.9],
  LS: [28.2, -29.6],
  LR: [-9.4, 6.4],
  LY: [17.2, 26.3],
  MG: [46.9, -18.8],
  MW: [34.3, -13.3],
  ML: [-2.0, 17.6],
  MR: [-10.9, 20.3],
  MX: [-102.5, 23.6],
  FM: [150.5, 6.9],
  MD: [28.4, 47.4],
  MN: [103.8, 46.9],
  MA: [-7.1, 31.8],
  MZ: [35.5, -18.7],
  MM: [96.5, 21.9],
  NA: [18.5, -22.9],
  NP: [84.1, 28.4],
  NI: [-85.2, 12.9],
  NE: [8.1, 17.6],
  NG: [8.7, 9.1],
  PK: [69.3, 30.4],
  PW: [134.6, 7.5],
  PA: [-80.8, 8.5],
  PG: [143.9, -6.3],
  PY: [-58.4, -23.4],
  PE: [-75.0, -9.2],
  PH: [122.9, 12.9],
  RW: [29.9, -2.0],
  WS: [-172.3, -13.8],
  ST: [6.6, 0.2],
  SN: [-14.5, 14.5],
  SL: [-11.8, 8.6],
  SB: [160.2, -9.6],
  SO: [46.2, 6.0],
  ZA: [25.1, -29.0],
  SS: [31.3, 6.9],
  SD: [29.9, 12.9],
  SR: [-56.0, 3.9],
  SZ: [31.5, -26.5],
  SY: [38.0, 35.0],
  TJ: [71.3, 38.9],
  TZ: [35.0, -6.4],
  TH: [101.0, 15.9],
  TL: [125.7, -8.9],
  TG: [0.8, 8.6],
  TO: [-175.2, -21.2],
  TN: [9.5, 33.9],
  TM: [59.6, 40.5],
  TV: [177.6, -7.5],
  UG: [32.3, 1.4],
  UA: [31.2, 48.4],
  UZ: [63.9, 41.4],
  VU: [167.0, -16.0],
  VE: [-66.6, 6.4],
  VN: [108.3, 14.1],
  YE: [47.6, 15.6],
  ZM: [27.8, -13.1],
  ZW: [29.2, -19.0],
};

export default countryCentroids;
